import { get }     from './client'
import { getShop } from './shop'

export type QueueActivityTab = 'CF_Activity' | 'SC_Activity' | 'ST_Activity' | 'CS_Activity'

export type AgentDayStats = {
  agent:             string
  sessions:          number
  completedSessions: number
  totalDurationMin:  number
  ahtMin:            number
  outcomes:          Record<string, number>
  checkinTime:       string | null
  checkoutTime:      string | null
  breakCount:        number
  totalBreakMin:     number
  anomalies:         string[]
}

export type LeaderboardEntry = {
  rank:              number
  agent:             string
  completedSessions: number
  ahtMin:            number
  totalDurationMin:  number
  topOutcome:        string | null
}

export type AnomalyFlag = {
  agent:  string
  type:   'too_fast' | 'no_checkout' | 'excessive_break'
  detail: string
}

export type HistoryStatsResponse = {
  agents:      AgentDayStats[]
  anomalies:   AnomalyFlag[]
  leaderboard: LeaderboardEntry[]
  date:        string
  tab:         QueueActivityTab
}

export type HistoryActivityResponse = {
  rows:    Array<Record<string, string>>
  headers: string[]
  total:   number
  date:    string
  tab:     QueueActivityTab
}

export async function getHistoryStats(
  tab:              QueueActivityTab,
  date?:            string,
  requestingAgent?: string,
): Promise<HistoryStatsResponse> {
  const shop   = getShop()
  const params = new URLSearchParams({ shop, tab })
  if (date)             params.set('date', date)
  if (requestingAgent)  params.set('requestingAgent', requestingAgent)
  return get<HistoryStatsResponse>(`/history/stats?${params}`)
}

export async function getHistoryActivity(
  tab:    QueueActivityTab,
  date?:  string,
  agent?: string,
  limit?: number,
): Promise<HistoryActivityResponse> {
  const shop   = getShop()
  const params = new URLSearchParams({ shop, tab })
  if (date)   params.set('date', date)
  if (agent)  params.set('agent', agent)
  if (limit)  params.set('limit', String(limit))
  return get<HistoryActivityResponse>(`/history/activity?${params}`)
}
